import React, { Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbarmenu from './components/Elements/Navbar';
import Footer from './components/Elements/Footer';
import Dashboard from "./components/Dashboard";
import UniqueCodeByUrl from "./components/UniqueCodeByUrl";
import NotFoundpage from "./components/NotFoundpage";
import FooterLogos from "./components/Elements/FooterLogs";
import UniqueCodeByUrlAgency from "./agencyComponents/UniqueCodeByUrl";
import Unsubscribeagency from "./unsubscribe/agency";
import Dashboardagency from "./agencyComponents/Dashboard";
function App() {
  document.title =  process.env.REACT_APP_NAME_TITLE_SUFFIX;
  return (
    <Suspense fallback={null}>
      <BrowserRouter>
        <Navbarmenu />
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/:code" element={<UniqueCodeByUrl/>} />
          <Route path="*" element={<NotFoundpage/>} />
          <Route path="/agency" element={<Dashboardagency />} />
          <Route path="/agency/:code" element={<UniqueCodeByUrlAgency/>} />
          <Route path="/agency/unsubscrible/:code" element={<Unsubscribeagency/>} />
          <Route path="/unsubscrible/:token" element={<Unsubscribeagency/>} />

          
        </Routes>
        <FooterLogos />
        <Footer />
      </BrowserRouter>
    </Suspense>
  );
}

export default App;
